import { FC } from 'react';
import { FontWeight } from '../../../styles/constants';
import { StyledLoading, H1Nav, H2, H3, H4, H1, H5 } from './Heading.styles';

interface Props {
  h1?: boolean;
  h2?: boolean;
  h3?: boolean;
  h4?: boolean;
  h5?: boolean;
  nav?: boolean;
  inverted?: boolean;
  small?: boolean;
  weight?: FontWeight;
  className?: string;
  title?: string;
}

export const Heading: FC<Props> = ({ className, children, h1, nav, h2, h3, h4, h5, ...rest }) => {
  const content = children || <StyledLoading />;

  const Wrapper = (() => {
    if (nav) return H1Nav;
    if (h2) return H2;
    if (h3) return H3;
    if (h4) return H4;
    if (h5) return H5;
    return H1;
  })();

  return (
    <Wrapper className={className} {...rest}>
      {content}
    </Wrapper>
  );
};
